<template>
  <div style="margin-top: -3rem;">
    <md-dialog-content v-if="renderComponent">
      <div class="ml-30 pt-30">
        <md-dialog-title style="margin-left: -2%; font-size: 2rem;">{{ options.Lang.Titelbilder_Kategorien_bearbeiten }}</md-dialog-title>
      </div>

      <div class="p-30" style="background-color: white; margin-top: 2rem;">
        <br>
        <table class="tableclass2-timeline" style="width: 100%;">
          <tr>
            <td style="width: 30%;padding-left: 13px;" class="categorie">
              {{options.Lang.Kategorie}}
            </td>
            <td style="width: 30%;" class="categorie">
              {{ options.Lang.defaultKat }}
            </td>
            <td style="width:20%;padding-left: 20px;" class="categorie">
            </td>
          </tr>

        </table>
        <table class="settingsTable" v-for="(cat, index) in categories" :key="index">
          <tr class="settingsTr">
            <td class="settingsTdPdf">
              {{ cat.name }}
            </td>
            <td class="verknüpfte">
              <md-field>
                <md-select v-model="cat.defaultCat" name="movie" id="movie" @md-selected="handleSelectChange(cat.name)">
                  <md-option  :value="true">{{ options.Lang.aktiviert }}</md-option>
                  <md-option  :value="false">{{ options.Lang.deaktiviert }}</md-option>
                </md-select> 
              </md-field>
              
            </td>
            <td style="width: 20%; text-align: right;">
              <md-button v-if="cat.defaultCat == 'false'" style="margin:0; min-width:50px"  @click="rmvCategorie(cat.name)">
                <md-icon>delete</md-icon>
              </md-button>
              <md-button style="margin:0; min-width:50px" @click="editCategorie(cat.id, cat.name)">
                <md-icon>edit</md-icon>
              </md-button>
              
            </td>
          </tr>
        </table>
        <br>
        <br>
        <h5>{{options.Lang.Kategorie_hinzufügen}}</h5>

        <form novalidate class="md-layout">
          <div class="md-layout-item">
            <md-field class="md-focused">
              <label for="filename"><strong>{{options.Lang.Kategorie}}</strong></label>
              <md-input tabindex="4" name="fileName" @change="getCatName" id="fileName" required
                :placeholder=options.Lang.Kategorie />
              <div style="float: right;">
                <md-button tabindex="7" class="md-raised md-primary" id="uploadButton" disabled @click="uploadCat()"><strong>{{options.Lang.Speichern}}</strong>
                </md-button>
                
              </div>
            </md-field>
          </div>
          <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
        </form>
      </div>
      


      <Success :options="options"></Success>
    </md-dialog-content>
    <!--////-->
    <div class="editCat" v-if="editCat">
      <div class="bgEdit"></div>
      <div class="contentEdit">
        <div class="md-layout-item">
            <md-field class="md-focused dFlex">
              <label for="filename"><strong>{{options.Lang.Kategorie_bearbeiten}}</strong></label>
              <md-input tabindex="4" :placeholder="editnewName" :value="editnewName" name="fileName" @change="getNewCatName" id="fileName" required />
              <div class="buttonContainer">
                <md-button tabindex="7" class="md-raised md-primary" id="sendButton" @click="uploadNewCat()">{{ options.Lang.Speichern }}</md-button>
                <md-button tabindex="8" class="md-raised secondary" @click="closeEdit()"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>
              </div>
            </md-field>
          </div>
      </div>
    </div>
    <div>
  </div>
</div>
</template>
  
<script>
import * as moment from 'moment'
import { validationMixin } from 'vuelidate'
import Success from '../../components/dialogs/Success.vue'
import Error from '../../components/dialogs/Error.vue'



export default {
  name: 'formPdfCategorie',
  mixins: [validationMixin],
  components: {
    Success,
    Error,
  },
  props: {
    options: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    fileName: null,
    selectBrand: null,
    pdfs: [],
    Dpdf: null,
    uploadFile: null,
    renderComponent: false,
    brands:[],
    editnewName: null,
    finalNew: null,
    editnewId: null,
    editCat: false,
    newCat: null,
    categories: [],
    check: false
  }),
  created() {
  },
  updated(){
    if(this.newCat == null || this.newCat == "" ||  this.newCat == "null"){
      let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
    }else{
      let button = document.getElementById("uploadButton")
      button.removeAttribute("disabled")
    }
  },
  mounted() {
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
    let self = this;
    this.doPost({}, 'getAllCategoriesToImages', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
        self.renderComponent = true;
      }
    });
 
  },
  watch: {

  },
  methods: {
    async handleSelectChange(value) {
      let myData = {
        status: value
      }
      let self = this;
      
      await this.doPost({}, 'setImgCatToFalse', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
        }
      });
      await this.doPost({data: myData}, 'setImgCatToTrue', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
        }
      });
      await location.reload();
    },
    async getBrandName(){
      let self = this;
      self.renderComponent = false;
      self.pdfs.forEach(pdf =>{
          self.brands.forEach(brand =>{
            if(pdf.branding_id == brand.id){
              pdf.showBrand = brand.adresse
            }
          })
        })
        self.renderComponent = true;
        
    },
    getBrandForPdf(){
    },
    
    removePDF(pdfId) {
      this.pdfs.forEach(element =>{
        if(element.id == pdfId){
          this.Dpdf = element;
        }
      })
      this.options.isUploading = true;
      let self = this;
      //remove from allgemein table
      self.doPost({data: this.Dpdf}, 'removeAllgemeinPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //do stuff
          self.options.isUploading = false;
          self.doPost({}, 'getAllgemeinPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.pdfs = result;
      }
    });

        }
      })
     
      
      self.doPost({data: this.Dpdf}, 'removeAllgemeinPdfTrip', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.getBrandName();
        }
      });
      
    },
    async uploadPDF() {
     let self = this;
     const toBase64 = file => new Promise((resolve, reject) => {
       const reader = new FileReader();
       reader.readAsDataURL(file);
       reader.onload = () => resolve(reader.result);
       reader.onerror = error => reject(error);
     });

     async function Main(blub) {
       self.options.isUploading = true;
       const file = blub;
       let baseFile = await toBase64(file);

       let uploadData = {
         file: baseFile,
         pdfName: self.fileName,
         brand: self.selectBrand
       }

       uploadData.dir = 'pdfs/' + uploadData.pdfName + '.pdf',
       uploadData.newDir = 'pdfs/' 
       
         self.doPost({data: uploadData}, 'uploadAllgemeinPdf', function (res) {
         if (res.data.status === 'error') {
           self.help.log(self.$t(res.msg), false, true);
           self.fileName  = ""
        self.uploadFile = ""
        self.selectBrand = ""
         } else {
          
           self.fileName  = ""
        self.uploadFile = ""
        self.selectBrand = ""
           self.options.isUploading = false;
           self.doPost({}, 'getAllgemeinPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.pdfs = result;
        self.fileName  = ""
        self.uploadFile = ""
        self.selectBrand = ""
      }
    });
          }
       });
       
     }

     if (this.uploadFile == "" || this.fileName == "" || this.selectBrand == "") {
       
       this.options.isUploading = false;
     }else{
        await Main(this.uploadFile);
        await window.setTimeout(this.getBrandName(), 1000) 
     }
     
       
     
     
   },
    checkInput(){
      if (this.uploadFile == null || this.fileName == null || this.selectBrand == null) {
        this.options.isUploading = false;
        this.options.showError = true;
      }else{
        this.uploadPDF();
      }
    },
    getFileName(event) {
      this.fileName = event.target.value;
    },
    getUploadFile(event) {
      this.uploadFile = event.target.files[0];
    },
    async getCount(){
      this.renderComponent = false;
      let self = this;
      await this.doPost({}, 'getAllPdfs', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result2 = res.data.data;
        self.categories.forEach(cat => {
          cat.count = 0;
        })
        self.categories.forEach(cat => {
          result2.forEach(dbEntrie =>{
          if(cat.name == dbEntrie.name){
            cat.count++
          }
        })
        })
        self.renderComponent = true;    
      }
    });
    await self.$nextTick(function(){
      self.renderComponent = true;
    });
    },
    editCategorie(id, name){
      this.editCat = true
      this.editnewId = id
      this.editnewName = name
    },
    async closeEdit(){
      this.editCat = false
      let self = this;
    this.doPost({}, 'getAllCategoriesToImages', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
      }
    });
    self.getCount();
    },
    getNewCatName(event) {
      this.finalNew = event.target.value;
      if(this.finalNew == null || this.finalNew == ""){
        let button = document.getElementById("sendButton")
        button.setAttribute("disabled", true)
        
      }else{
        let button = document.getElementById("sendButton")
        button.removeAttribute("disabled")
      }
    },
    async rmvCategorie(id) {
      this.renderComponent = false;
      let defaultCat;
      this.categories.forEach(cat =>{
        if(cat.defaultCat == "true"){
          defaultCat = cat.name
        }
      })
      let myData = {
        defaultCat: defaultCat,
        oldCat: id,
      }
      let self = this;
      await self.doPost({ data: myData }, 'removeAllImagesToCat', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.refreshDialog();
        }
      });
      await self.doPost({ data: myData }, 'removeCatToImage', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.refreshDialog();
        }
      });
    await self.doPost({}, 'getAllCategoriesToImages', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
      }
    });
    self.renderComponent = true;
    await location.reload();
    },
    refreshDialog() {
      let self = this;
      self.options.showPdfCategorieForm = false;
      self.$nextTick(() => {
        self.options.showPdfCategorieForm = true;
      });
    },
    uploadNewCat(){
      this.categories.forEach(element => {
        if (element.name == this.finalNew) {
          this.check = true
          this.refreshDialog();
        }
      });
      if (this.check == false) {
        this.uploadCatFullNew();
      }
    },
    uploadCatFullNew(){
      if (this.finalNew != null) {
        let self = this;
        let mydata = {
          id: this.editnewId,
          name: this.finalNew
        }
        self.doPost({ data: mydata }, 'editCategorieImg', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.check = 0;
          }
        });
        mydata.oldName = this.editnewName;
        
        self.doPost({ data: mydata }, 'editCategorieNameForAllImages', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.check = 0;
            self.options.showSuccess = true;
            self.refreshDialog();
          }
        });
    self.doPost({}, 'getAllCategoriesToImages', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
      }
    });
    self.getCount();
      } else {
        this.options.showError = true;
      }
    },
    uploadCat() {
      this.categories.forEach(element => {
        if (element.name == this.newCat) {
          this.check = true
          this.refreshDialog();
        }
      });
      if (this.check == false) {
        this.uploadCatFull();
      }
    },
    async uploadCatFull() {
      this.renderComponent = false;
      if (this.newCat != null) {
        let self = this;
        await self.doPost({ data: self.newCat }, 'uploadCatToImage', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.check = 0;
          }
        });
        await self.doPost({}, 'getAllCategoriesToImages', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
      }
    });
      } else {
        this.options.showError = true;
      }

      self.renderComponent = true;
      await location.reload();
    },
    getCatName(event) {
      this.newCat = event.target.value;
      if(this.newCat == null || this.newCat == "" ||  this.newCat == "null"){
      let button = document.getElementById("uploadButton")
      button.setAttribute("disabled", true)
    }else{
      let button = document.getElementById("uploadButton")
      button.removeAttribute("disabled")
    }
    },
    closeDialog() {
      this.options.showPdfCategorieForm = false;
    }
  }
}
</script>
<style>
.bgEdit{
  background-color: black;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}
.editCat{
  z-index: 111111;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.contentEdit{
  padding: 4rem;
  background-color: white;
  position: absolute;
  height: auto;
  top: 50% !important;
  width: 60%;
  left: 20%;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
  vertical-align: bottom;
  border-collapse: collapse;

}

.settingsTable {
  width: 100%;
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}

.settingsTr {
  height: 50px;
  background-color: white;
  border-bottom: 0.4000000059604645px solid #97979767;
}

.settingsTdPdf {
  width: 30%;
  padding-left: 13px;
}

.verknüpfte {
  width: 30%;
  padding-left: 2px;
}

#fileName{
  -webkit-text-fill-color: black !important;
}
.dFlex {
  display: flex;
  flex-direction: column !important;
}
.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 3rem;
  margin-bottom: -1rem;
}
</style>